import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class ErrorManagerService {
  constructor(private sanitizer: DomSanitizer) {}

  public getValidationErrors(error: Error | any) {
    const errors = [];
    this._getValidationErrors(error).forEach(item => {
      if (item.messages !== undefined) {
        item.messages.forEach(message => {
          errors.push(message);
        });
      }
    });
    return errors;
  }

  public getValidationFields(error: Error | any) {
    const errors: Array<string> = [];
    this._getValidationErrors(error).forEach(item => {
      if (item.field !== undefined) {
        errors.push(item.field);
      }
    });
    return Array.from(new Set(errors)); // Removes duplicates
  }

  public errorToPrint(error: Error | any, list: boolean = true) {
    if (list) {
      let text = '';
      this.getValidationErrors(error).forEach(item => {
        text += '<p>' + item + '</p>';
      });

      return this.sanitizer.bypassSecurityTrustHtml(text);
    } else {
      return this.sanitizer.bypassSecurityTrustHtml(this.getValidationErrors(error).join(''));
    }
  }

  private _getValidationErrors(error: Error | any) {
    if (error.errors !== undefined) {
      if (error.errors instanceof Array) {
        return error.errors;
      }
      return [error.errors];
    }
    if (error.message !== undefined) {
      return [
        {
          field: null,
          messages: [error.message],
        },
      ];
    }
    return [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/error-manager.service.ts